// Simple IndexedDB queue for offline gestiones.
// Stores raw payload + optional photo Blobs and replays them when back online.

const DB_NAME = 'ciudad-inteligente-offline';
const DB_VERSION = 1;
const STORE = 'pending_gestiones';

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'id', autoIncrement: true });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    const result = fn(store);
    t.oncomplete = () => resolve(result);
    t.onerror = () => reject(t.error);
  });
}

export async function enqueueGestion(payload, photos) {
  const photoBlobs = [];
  for (const f of (photos || [])) {
    if (f instanceof Blob) photoBlobs.push({ name: f.name, blob: f, type: f.type });
  }
  return await tx('readwrite', (store) => new Promise((res) => {
    const req = store.add({
      payload,
      photos: photoBlobs,
      created_at: new Date().toISOString(),
    });
    req.onsuccess = () => res(req.result);
  }));
}

export async function listPending() {
  return await tx('readonly', (store) => new Promise((res) => {
    const req = store.getAll();
    req.onsuccess = () => res(req.result || []);
  }));
}

export async function countPending() {
  return await tx('readonly', (store) => new Promise((res) => {
    const req = store.count();
    req.onsuccess = () => res(req.result || 0);
  }));
}

export async function removePending(id) {
  return await tx('readwrite', (store) => new Promise((res) => {
    const req = store.delete(id);
    req.onsuccess = () => res(true);
  }));
}

/**
 * Try to sync all queued gestiones. Returns {succeeded, failed}.
 * `apiPost(path, body)` should be your axios instance's POST.
 */
export async function syncPending(apiPost, apiUpload) {
  const pending = await listPending();
  let succeeded = 0;
  let failed = 0;
  for (const item of pending) {
    try {
      const res = await apiPost('/gestiones', item.payload);
      const gestionId = res.data?.id;
      // Upload photos if the endpoint exists (best-effort)
      if (gestionId && item.photos?.length && apiUpload) {
        for (const p of item.photos) {
          try {
            const fd = new FormData();
            fd.append('file', new File([p.blob], p.name || 'foto.jpg', { type: p.type || 'image/jpeg' }));
            await apiUpload(`/gestiones/${gestionId}/foto`, fd);
          } catch (e) { /* keep going on photo failures */ }
        }
      }
      await removePending(item.id);
      succeeded++;
    } catch (e) {
      failed++;
      // stop early if it's an auth error (401) — user needs to relogin
      if (e.response?.status === 401) break;
    }
  }
  return { succeeded, failed };
}
